var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://spaboot.de/docs/agb.pdf","target":"_agb"}},[_vm._t("default",function(){return [_vm._v("AGB")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }